import clsx from 'clsx';
import { FC } from 'react';
import { Image, Types } from '@marriott/mi-ui-library';
import { MerchandisingHeroBannerAssetProps } from './MerchandisingHeroBannerAsset.types';
import { StyledVerticalImageContainer, StyledFontIcon, StyledLogoImage } from './MerchandisingHeroBannerAsset.styles';
import { URL_CONSTANTS } from '@marriott/shared/mi-helper-utils';
const { AssetVariation, ImageAspectRatio } = Types;
const { FONT_ICON } = AssetVariation;
const { SIZE_3x1 } = ImageAspectRatio;
const { PLACEHOLDER_IMAGE } = URL_CONSTANTS;
const { VERTICAL_IMAGE } = AssetVariation;
const MerchandisingHeroBannerAsset: FC<MerchandisingHeroBannerAssetProps> = props => {
  const {
    fileReferenceImageVertical,
    imgAltText,
    assetsVariation,
    verticalImageAltText,
    heroSize,
    fontIcon,
    fontIconAltText,
    logoImage,
    cobrandmathhero,
    isCopyBlockWidthWide,
  } = props;
  const isVerticalImage = !!(assetsVariation && assetsVariation === VERTICAL_IMAGE && fileReferenceImageVertical);
  return (
    <>
      {isCopyBlockWidthWide && isVerticalImage && fileReferenceImageVertical && (
        <StyledVerticalImageContainer>
          <img
            src={fileReferenceImageVertical}
            className={`styled${assetsVariation}`}
            alt={verticalImageAltText}
            title={verticalImageAltText}
            data-src={PLACEHOLDER_IMAGE}
          />
        </StyledVerticalImageContainer>
      )}
      {!isVerticalImage && (
        <div className="row">
          {assetsVariation === FONT_ICON && fontIcon ? (
            <div className="col-12 col-md-4 col-lg-6">
              <StyledFontIcon
                fontIcon={fontIcon}
                className={`m-icon brand-logo-${fontIcon}`}
                aria-labelledby={fontIconAltText || ''}
                data-testid={fontIcon}
              />
            </div>
          ) : (
            logoImage && (
              <StyledLogoImage
                className={clsx('credit-card', {
                  'hb-flex': heroSize === SIZE_3x1,
                })}
                cobrandmathhero={cobrandmathhero as boolean}
              >
                <Image
                  title={imgAltText || 'Hero Card Image'}
                  customClass="logo-image"
                  loading="lazy"
                  defaultImageURL={logoImage}
                  altText={imgAltText}
                  dynamic={false}
                ></Image>
              </StyledLogoImage>
            )
          )}
        </div>
      )}
    </>
  );
};

export default MerchandisingHeroBannerAsset;
